export default function dataOpen(data: string) {
  const dataString = atob(data);
  const newWindow = window.open('');
  if (newWindow !== null) {
    newWindow.document.write(dataString);
    newWindow.focus();
  }
}
